import * as React from 'react';

import { BreadcrumbsV2 } from '@uncinc/react-drupal-core';

import './style.scss';

const Breadcrumbs = () => (
  <BreadcrumbsV2 showHomeIcon={false} />
);

export default Breadcrumbs;
